<div *ngIf="projectControlItems && projects">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;    margin-left: 40px;">RizkMap</h2>
    </div>

    <div style="display: flex; flex-direction: row;" class="back-button">
      <button mat-raised-button class="button" [routerLink]="['/projects', 'project', projectId]">
        <i class="pi pi-arrow-left"></i> Back to project
      </button>
    </div>
  </div>
  <mat-tab-group>
    <mat-tab label="RizkMap">
      <p-table [value]="projectControlItems" rowGroupMode="subheader" dataKey="controlItem.category"
        expandableRowGroups="true" [paginator]="true" [rows]="100" [pageLinks]="3"
        [rowsPerPageOptions]="[10, 20, 50, 100]" [reorderableColumns]="true" (onSort)="updateRowGroupMetaData()">
        <ng-template pTemplate="header">
          <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
            <th *ngFor="let col of cols" [pSortableColumn]="col.field" style="text-align: center;width: 20%">
              Source - {{projects[0].name}}
              <span class="pi pi-list" style="top: 2px;margin-left: 6px;position: relative;"
                *ngIf="isMappingTemplateVisible" (click)="selectMappingTemplate(projects[0])"></span>
              <span class="pi pi-arrow-circle-right" style="top: 2px;margin-left: 6px;position: relative;"
                *ngIf="isMappingTemplateVisible" (click)="applyMapping(projects[0])"></span>
              <!--p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon-->
            </th>
            <th *ngFor="let project of projects" style="text-align: center;width: 10%">{{project.name}}
              <span class="pi pi-list" *ngIf="isMappingTemplateVisible"
                style="top: 2px;margin-left: 6px;position: relative;cursor:pointer"
                (click)="selectMappingTemplate(project)"></span>
              <span class="pi pi-arrow-circle-right" style="top: 2px;margin-left: 6px;position: relative;cursor:pointer"
                *ngIf="isMappingTemplateVisible" (click)="applyMapping(project)"></span>
              <span class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Mappings'"
                style="top: 2px;margin-left: 6px;position: relative;cursor:pointer"
                [popoverMessage]="'Are you sure you wish to delete all mapping relationships?'" [appendToBody]="true"
                [confirmText]="'Yes'" [cancelText]="'No'" placement="left" (confirm)="removeMapping(project)"></span>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header"
            *ngIf="rowGroupMetadata && rowGroupMetadata[item.controlItem.category].index === rowIndex">
            <td [attr.colspan]="projects?.length+ + 1">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item['controlItem'].complianceArea.name}} - {{item['controlItem'].category}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
          <tr *ngIf="!item.controlItem.hasParent">
            <td style="vertical-align: top;">
              <div style="display: flex">
                <span href="#" *ngIf="item.subItems?.length"
                  (click)="subVisible[item.projectControlItemId] = !subVisible[item.projectControlItemId]"
                  style="margin-left: 14px;">
                  <i
                    [ngClass]="subVisible[item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </span>

                <span style="cursor: pointer"
                  (click)="item.controlItem.descriptionVisible = !item.controlItem.descriptionVisible">{{item.controlItem.complianceAreaControlId}}
                  {{item.controlItem.category}}</span>

                <div style="display: flex"><img src="../../../assets/icon/broadcast.svg" height="20px"
                    *ngIf="pairingMap[item.projectControlItemId]?.cloned" />
                  <img style="margin-left: 5px;margin-top:2px" src="../../../assets/icon/crossmap.png" height="20px"
                    *ngIf="pairingMap[item.projectControlItemId]?.mapped" />
                </div>

                <ng-container>
                  <mat-checkbox class="example-margin " style="margin-left:7px;margin-top:-3px"
                    [ngModel]="selectAllChecked[item.projectControlItemId]"
                    [indeterminate]="selectIndeterminate[item.projectControlItemId]"
                    (ngModelChange)="handleSelectAllChange($event, item.projectControlItemId)"></mat-checkbox>
                </ng-container>
              </div>

              <div [@expandCollapse]="item.controlItem.descriptionVisible ? 'expanded' : 'collapsed'">
                <!-- {{item.controlItem.description}} -->

                <section>
                  <!-- Template to show when there are no targets -->
                  <ng-container>
                    <div style="display: grid;width:fit-content;margin-left:15px">
                      <div class="Subcompoment-boxes" (click)="item.showImplementation = !item.showImplementation">
                        <h2 class="checkbox-heading">Implementation</h2>
                        <i [ngClass]="item.showImplementation ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                      </div>

                      <div [@expandCollapse]="item.showImplementation ? 'expanded' : 'collapsed'"
                        style="display: grid;">
                        <div class="checkboxes-div">
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[item.projectControlItemId]?.ics1"
                            (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'ics1')">ICS1</mat-checkbox>
                          <ng-container *ngIf="checkboxStates[item.projectControlItemId]?.ics1">
                            <mat-select [(ngModel)]="tempICS1[item.projectControlItemId]"
                              (ngModelChange)="setSelectedICS($event, item.projectControlItemId, 'ICS1')"
                              class="select-input"
                              (selectionChange)="handleSelectChange($event, item.projectControlItemId, 'ICS1')"
                              (click)="setDefaultICS(item.projectControlItemId)">
                              <mat-option *ngFor="let option of updateSelectOptions(item.projectControlItemId, 'ICS1')"
                                [value]="option" class="options-class"><p style="font-size: 12px;">{{ option }}</p></mat-option>
                            </mat-select>
                          </ng-container>
                        </div>
                        <div class="checkboxes-div"  *ngIf="item.noOfIcsSections === '2' || item.noOfIcsSections === '3'">
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[item.projectControlItemId]?.ics2"
                            (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'ics2')">ICS2</mat-checkbox>
                          <ng-container *ngIf="checkboxStates[item.projectControlItemId]?.ics2">
                            <mat-select [(ngModel)]="tempICS2[item.projectControlItemId]"
                              (ngModelChange)="setSelectedICS($event, item.projectControlItemId, 'ICS2')"
                              class="select-input"
                              (selectionChange)="handleSelectChange($event, item.projectControlItemId, 'ICS2')"
                              (click)="setDefaultICS(item.projectControlItemId)">
                              <mat-option *ngFor="let option of updateSelectOptions(item.projectControlItemId, 'ICS2')"
                                [value]="option" class="options-class">{{ option }}</mat-option>
                            </mat-select>

                          </ng-container>
                        </div>
                        <div class="checkboxes-div" *ngIf="item.noOfIcsSections === '3'">
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[item.projectControlItemId]?.ics3"
                            (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'ics3')">ICS3</mat-checkbox>
                          <ng-container *ngIf="checkboxStates[item.projectControlItemId]?.ics3">
                            <mat-select [(ngModel)]="tempICS3[item.projectControlItemId]"
                              (ngModelChange)="setSelectedICS($event, item.projectControlItemId, 'ICS3')"
                              class="select-input"
                              (selectionChange)="handleSelectChange($event, item.projectControlItemId, 'ICS3')"
                              (click)="setDefaultICS(item.projectControlItemId)">
                              <mat-option *ngFor="let option of updateSelectOptions(item.projectControlItemId, 'ICS3')"
                                [value]="option" class="options-class">{{ option }}</mat-option>
                            </mat-select>
                          </ng-container>
                        </div>
                        <!-- <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.implementationControlStatement"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'implementationControlStatement')">Implementation
                          Control Statement</mat-checkbox> -->
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.controlsTesting"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'controlsTesting')">Controls
                          Testing</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.inheritedControls"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'inheritedControls')">Inherited
                          Controls</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.gaps"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'gaps')">Gaps</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.workstream"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'workstream')">Workstream</mat-checkbox>
                      </div>
                      <div class="Subcompoment-boxes" (click)="item.showArtifacts = !item.showArtifacts">
                        <h2 class="checkbox-heading">Artifacts & Evidence</h2>
                        <i [ngClass]="item.showArtifacts ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

                      </div>
                      <div [@expandCollapse]="item.showArtifacts ? 'expanded' : 'collapsed'" style="display: grid;">
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.evidence"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'evidence')">Evidence</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.policy"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'policy')">Policy</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.documentation"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'documentation')">Documentation</mat-checkbox>
                      </div>
                      <div class="Subcompoment-boxes" (click)="item.showAssessment = !item.showAssessment">
                        <h2 class="checkbox-heading">Assessment</h2>
                        <i [ngClass]="item.showAssessment ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

                      </div>
                      <div [@expandCollapse]="item.showAssessment ? 'expanded' : 'collapsed'" style="display: grid;">
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.intAssessment"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'intAssessment')">Int
                          Assessment</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.thirdPartySecurity"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'thirdPartySecurity')">3P
                          Security</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.thirdPartyRisk"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'thirdPartyRisk')">3P
                          Risk</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.areaSpecific"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'areaSpecific')">Area
                          Specific</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.scoring"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'scoring')">Scoring</mat-checkbox>
                      </div>
                      <div class="Subcompoment-boxes" (click)="item.showNist = !item.showNist">

                        <h2 class="checkbox-heading">NIST FedRAMP</h2>
                        <i [ngClass]="item.showNist ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

                      </div>
                      <div [@expandCollapse]="item.showNist ? 'expanded' : 'collapsed'" style="display: grid;">
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.organizationalParameters"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'organizationalParameters')">Organizational
                          Parameters</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox"
                          [ngModel]="checkboxStates[item.projectControlItemId]?.controlOrigination"
                          (ngModelChange)="handleCheckboxChange($event, item.projectControlItemId, 'controlOrigination')">Control
                          Origination</mat-checkbox>
                      </div>
                    </div>
                  </ng-container>
                </section>
                  <div>
                    <div style="cursor: pointer;display: flex;gap: 13px;padding: 2px;" (click)="item.controlItem.descriptionsVisible = !item.controlItem.descriptionsVisible">
                      <h3 class="checkbox-heading">Control Description</h3>
                      <i style="margin-top:-2px" [ngClass]="item.controlItem.descriptionsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    </div>
             <div class="Summary" *ngIf="item.controlItem.descriptionsVisible"
                   [innerHTML]="item.controlItem.description"></div>

                  </div>
              </div>
            </td>
            <td style="vertical-align: top;" *ngFor="let project of projects">

              <div style="display:flex;justify-content:center;gap:10px">

                <span *ngFor="let pair of (proposedPairingMap[item.projectControlItemId] || {})[project.projectId]"
                  style="color:#ddd; cursor: pointer">
                  <span
                    (click)="addProposedPair(pair.fromControlItemId, pair.toControlItemId)">{{pair.toControlItemName}}</span>
                </span>
                <span class="pi pi-plus" (click)="addPair(item.projectControlItemId, project.projectId)"></span>
              </div>

              <div style="display:flex;justify-content:center;gap:10px">
                <div *ngFor="let pair of (pairingMap[item.projectControlItemId] || {})[project.name]">
                  <div class="pairing-div">
                    <p>{{pair.toControlItemName}}</p>
                    <i class="pi pi-trash" (click)="deletePair(pair.mappedItemId)"></i>
                    <!-- <i class="pi pi-pencil"  *ngIf="!pair.isEditing" (click)="pair.isEditing = true" ></i> -->
                    <div *ngIf="pair.isEditing">
                      <i class="pi pi-times" (click)="pair.isEditing = false"></i>
                      <i class="pi pi-check" style="margin-left:10px;font-size:15px; color:orange"
                        (click)="saveEdit(pair)"></i>
                    </div>
                  </div>
                  <div [@expandCollapse]="item.controlItem.descriptionVisible ? 'expanded' : 'collapsed'"
                    style="display:flex;justify-content:center;gap:10px">
                    <div>

                      <div class="Subcompoment-boxes" (click)="pair.showImplementation = !pair.showImplementation">
                        <h2 class="checkbox-heading">Implementation
                        </h2>
                        <i [ngClass]="pair.showImplementation ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                      </div>
                      <div [@expandCollapse]="pair.showImplementation ? 'expanded' : 'collapsed'"
                        style="display: grid;">
                        <div style="display: flex;gap:5px">
                          <mat-checkbox class="small-checkbox" [(ngModel)]="pair.ics1" [disabled]="!pair.isEditing"
                            (change)="logValue(pair, item.controlItem.complianceAreaControlId)">ICS1</mat-checkbox>
                          <p style="margin-bottom: 0px;font-size: 12px;margin-top: 3px;color: grey;" *ngIf="pair.ics1 && pair.ics1Mappedwith">
                            --{{pair.ics1Mappedwith}}</p>
                        </div>
                        <div style="display: flex;gap:5px">
                          <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.ics2"
                            [disabled]="!pair.isEditing"
                            (change)="logValue(pair, item.controlItem.complianceAreaControlId)">ICS2</mat-checkbox>
                          <p style="margin-bottom: 0px;font-size: 12px;margin-top: 3px;color: grey;"  *ngIf="pair.ics2 && pair.ics2Mappedwith">
                            --{{pair.ics2Mappedwith}}
                          </p>
                        </div>
                        <div style="display: flex;gap:5px">
                          <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.ics3"
                            [disabled]="!pair.isEditing"
                            (change)="logValue(pair, item.controlItem.complianceAreaControlId)">ICS3</mat-checkbox>
                          <p style="margin-bottom: 0px;font-size: 12px;margin-top: 3px;color: grey;" *ngIf="pair.ics3 && pair.ics3Mappedwith">
                            --{{pair.ics3Mappedwith}}</p>
                        </div>
                        <!-- <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                          [(ngModel)]="pair.implementationControlStatement"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Implementation Control
                          Statement</mat-checkbox> -->
                        <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                          [(ngModel)]="pair.controlsTesting"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Controls
                          Testing</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                          [(ngModel)]="pair.inheritedControls"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Inherited
                          Controls</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                          [(ngModel)]="pair.gaps"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Gaps</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                          [(ngModel)]="pair.workstream"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Workstream</mat-checkbox>
                      </div>
                      <div class="Subcompoment-boxes" (click)="pair.showArtifacts = !pair.showArtifacts">
                        <h2 class="checkbox-heading">Artifacts & Evidence</h2>
                        <i [ngClass]="pair.showArtifacts ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                      </div>

                      <div [@expandCollapse]="pair.showArtifacts ? 'expanded' : 'collapsed'" style="display: grid;">
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.evidence"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Evidence</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.policy"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Policy</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.documentation"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Documentation</mat-checkbox>
                      </div>
                      <div class="Subcompoment-boxes" (click)="pair.showAssessment = !pair.showAssessment">
                        <h2 class="checkbox-heading">Assessment</h2>
                        <i [ngClass]="pair.showAssessment ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                      </div>
                      <div [@expandCollapse]="pair.showAssessment ? 'expanded' : 'collapsed'" style="display: grid;">
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.intAssessment"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Int
                          Assessment</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.thirdPartySecurity"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">3P Security</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.thirdPartyRisk"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">3P Risk</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.areaSpecific"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Area
                          Specific</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.scoring"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Scoring</mat-checkbox>
                      </div>
                      <div class="Subcompoment-boxes" (click)="pair.showNist = !pair.showNist">
                        <h2 class="checkbox-heading">NIST FedRAMP</h2>
                        <i [ngClass]="pair.showNist ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                      </div>
                      <div [@expandCollapse]="pair.showNist ? 'expanded' : 'collapsed'" style="display: grid;">
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.organizationalParameters"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Organizational
                          Parameters</mat-checkbox>
                        <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.controlOrigination"
                          [disabled]="!pair.isEditing"
                          (change)="logValue(pair, item.controlItem.complianceAreaControlId)">Control
                          Origination</mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="subVisible[item.projectControlItemId] && item.complianceArea?.hasLevels">
            <ng-container *ngFor="let subItemLevel of item.subItemLevels">
              <tr>
                <td [attr.colspan]="projects?.length+ + 1" style="padding-left: 30px;">
                  <span href="#" *ngIf="item.subItems?.length"
                    (click)="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level] = !subVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
                    <i
                      [ngClass]="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  </span>
                  {{subItemLevel.level}}
                </td>
              </tr>
              <ng-container *ngIf="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
                <tr *ngFor="let subIitem of subItemLevel.subItems">
                  <td style="padding-left: 40px;cursor: pointer;"
                    (click)="subIitem.controlItem.descriptionVisible = !subIitem.controlItem.descriptionVisible">
                    {{subIitem.controlItem.complianceAreaControlId}} {{subIitem.controlItem.category}}
                    <img src="../../../assets/icon/broadcast.svg" height="20px"
                      *ngIf="pairingMap[subIitem.projectControlItemId]?.cloned" />
                    <img src="../../../assets/icon/crossmap.png" height="20px"
                      *ngIf="pairingMap[subIitem.projectControlItemId]?.mapped" />
                    <div *ngIf="subIitem.controlItem.descriptionVisible">
                      {{subIitem.controlItem.description}}
                    </div>
                  </td>
                  <td style="text-align: center" *ngFor="let project of projects">
                    <span *ngFor="let pair of (pairingMap[subIitem.projectControlItemId] || {})[project.name]"
                      [ngStyle]="{fontWeight: pair.isPrimary ? 'bold' : 'normal'}"><span>{{pair.toControlItemName}}</span><span
                        class="pi pi-trash" (click)="deletePair(pair.mappedItemId)"></span> </span>
                    <span
                      *ngFor="let pair of (proposedPairingMap[subIitem.projectControlItemId] || {})[project.projectId]"
                      style="color:#ddd; cursor: pointer"><span
                        (click)="addProposedPair(pair.from.projectControlItemId, pair.to.projectControlItemId)">{{pair.to.controlItem.complianceAreaControlId}}</span></span>
                    <span class="pi pi-plus" (click)="addPair(subIitem.projectControlItemId, project.projectId)"></span>

                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="subVisible[item.projectControlItemId] && !item.complianceArea?.hasLevels">
            <tr *ngFor="let subIitem of item.subItems">
              <td style="padding-left: 40px; vertical-align: top;">
                <div style="display:flex;margin-left: 25px">
                  <p style="cursor:pointer"
                    (click)="subIitem.controlItem.descriptionVisible = !subIitem.controlItem.descriptionVisible">
                    {{subIitem.controlItem.complianceAreaControlId}} {{subIitem.controlItem.category}}</p>
                  <img src="../../../assets/icon/broadcast.svg" height="20px"
                    *ngIf="pairingMap[subIitem.projectControlItemId]?.cloned" />
                  <img src="../../../assets/icon/crossmap.png" style="margin-left: 5px;margin-top:2px" height="20px"
                    *ngIf="pairingMap[subIitem.projectControlItemId]?.mapped" />

                  <ng-container>
                    <mat-checkbox class="example-margin" style="margin-left:7px;margin-top:-3px"
                      [ngModel]="selectAllChecked[subIitem.projectControlItemId]"
                      [indeterminate]="selectIndeterminate[subIitem.projectControlItemId]"
                      (ngModelChange)="handleSelectAllChange($event, subIitem.projectControlItemId)"></mat-checkbox>
                  </ng-container>
                </div>
                <div *ngIf="subIitem.controlItem.descriptionVisible">
                  <section>

                    <!-- Template to show when there are no targets -->
                    <ng-container>
                      <div style="display: grid;width:fit-content;margin-left:15px">
                        <div class="Subcompoment-boxes"
                          (click)="subIitem.showImplementation = !subIitem.showImplementation">
                          <h2 class="checkbox-heading">Implementation</h2>
                          <i [ngClass]="subIitem.showImplementation ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                        </div>

                        <div [@expandCollapse]="subIitem.showImplementation ? 'expanded' : 'collapsed'"
                          style="display: grid;">
                          <div class="checkboxes-div" >
                            <mat-checkbox class="example-margin small-checkbox"
                              [ngModel]="checkboxStates[subIitem.projectControlItemId]?.ics1"
                              (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'ics1')">ICS1</mat-checkbox>
                            <ng-container *ngIf="checkboxStates[subIitem.projectControlItemId]?.ics1">
                              <mat-select [(ngModel)]="tempICS1[subIitem.projectControlItemId]"
                                (ngModelChange)="setSelectedICS($event, subIitem.projectControlItemId, 'ICS1')"
                                class="select-input"
                                (selectionChange)="handleSelectChange($event, subIitem.projectControlItemId, 'ICS1')"
                                (click)="setDefaultICS(subIitem.projectControlItemId)">
                                <mat-option
                                  *ngFor="let option of updateSelectOptions(subIitem.projectControlItemId, 'ICS1')"
                                  [value]="option" class="options-class">{{ option }}</mat-option>
                              </mat-select>
                            </ng-container>
                          </div>
                          <div class="checkboxes-div"  *ngIf="subIitem.noOfIcsSections === '2' || subIitem.noOfIcsSections === '3'">

                            <mat-checkbox class="example-margin small-checkbox"
                              [ngModel]="checkboxStates[subIitem.projectControlItemId]?.ics2"
                              (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'ics2')">ICS2</mat-checkbox>


                            <ng-container *ngIf="checkboxStates[subIitem.projectControlItemId]?.ics2">
                              <mat-select [(ngModel)]="tempICS2[subIitem.projectControlItemId]"
                                (ngModelChange)="setSelectedICS($event, subIitem.projectControlItemId, 'ICS2')"
                                class="select-input"
                                (selectionChange)="handleSelectChange($event, subIitem.projectControlItemId, 'ICS2')"
                                (click)="setDefaultICS(subIitem.projectControlItemId)">
                                <mat-option
                                  *ngFor="let option of updateSelectOptions(subIitem.projectControlItemId, 'ICS2')"
                                  [value]="option" class="options-class">{{ option }}</mat-option>
                              </mat-select>
                            </ng-container>

                          </div>
                          <div class="checkboxes-div"  *ngIf="subIitem.noOfIcsSections === '3'">

                            <mat-checkbox class="example-margin small-checkbox"
                              [ngModel]="checkboxStates[subIitem.projectControlItemId]?.ics3"
                              (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'ics3')">ICS3</mat-checkbox>
                            <ng-container *ngIf="checkboxStates[subIitem.projectControlItemId]?.ics3">
                              <mat-select [(ngModel)]="tempICS3[subIitem.projectControlItemId]"
                                (ngModelChange)="setSelectedICS($event, subIitem.projectControlItemId, 'ICS3')"
                                class="select-input"
                                (selectionChange)="handleSelectChange($event, subIitem.projectControlItemId, 'ICS3')"
                                (click)="setDefaultICS(subIitem.projectControlItemId)">
                                <mat-option
                                  *ngFor="let option of updateSelectOptions(subIitem.projectControlItemId, 'ICS3')"
                                  [value]="option" class="options-class">{{ option }}</mat-option>
                              </mat-select>
                            </ng-container>
                          </div>
                          <!-- <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.implementationControlStatement"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'implementationControlStatement')">Implementation
                            Control Statement</mat-checkbox> -->
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.controlsTesting"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'controlsTesting')">Controls
                            Testing</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.inheritedControls"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'inheritedControls')">Inherited
                            Controls</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.gaps"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'gaps')">Gaps</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.workstream"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'workstream')">Workstream</mat-checkbox>
                        </div>
                        <div class="Subcompoment-boxes" (click)="subIitem.showArtifacts = !subIitem.showArtifacts">
                          <h2 class="checkbox-heading">Artifacts & Evidence</h2>
                          <i [ngClass]="subIitem.showArtifacts ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

                        </div>
                        <div [@expandCollapse]="subIitem.showArtifacts ? 'expanded' : 'collapsed'"
                          style="display: grid;">
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.evidence"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'evidence')">Evidence</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.policy"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'policy')">Policy</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.documentation"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'documentation')">Documentation</mat-checkbox>
                        </div>
                        <div class="Subcompoment-boxes" (click)="subIitem.showAssessment = !subIitem.showAssessment">
                          <h2 class="checkbox-heading">Assessment</h2>
                          <i [ngClass]="item.showAssessment ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

                        </div>
                        <div [@expandCollapse]="subIitem.showAssessment ? 'expanded' : 'collapsed'"
                          style="display: grid;">
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.intAssessment"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'intAssessment')">Int
                            Assessment</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.thirdPartySecurity"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'thirdPartySecurity')">3P
                            Security</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.thirdPartyRisk"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'thirdPartyRisk')">3P
                            Risk</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.areaSpecific"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'areaSpecific')">Area
                            Specific</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.scoring"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'scoring')">Scoring</mat-checkbox>
                        </div>
                        <div class="Subcompoment-boxes" (click)="subIitem.showNist = !subIitem.showNist">

                          <h2 class="checkbox-heading">NIST FedRAMP</h2>
                          <i [ngClass]="subIitem.showNist ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>

                        </div>
                        <div [@expandCollapse]="subIitem.showNist ? 'expanded' : 'collapsed'" style="display: grid;">
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.organizationalParameters"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'organizationalParameters')">Organizational
                            Parameters</mat-checkbox>
                          <mat-checkbox class="example-margin small-checkbox"
                            [ngModel]="checkboxStates[subIitem.projectControlItemId]?.controlOrigination"
                            (ngModelChange)="handleCheckboxChange($event, subIitem.projectControlItemId, 'controlOrigination')">Control
                            Origination</mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </section>
                    <div>
                    <div style="cursor: pointer;display: flex;gap: 13px;padding: 2px;" (click)="subIitem.controlItem.descriptionsVisible = !subIitem.controlItem.descriptionsVisible">
                      <h3 class="checkbox-heading">Control Description</h3>
                      <i style="margin-top:-2px" [ngClass]="subIitem.controlItem.descriptionsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    </div>
             <div class="Summary" *ngIf="subIitem.controlItem.descriptionsVisible"
                   [innerHTML]="subIitem.controlItem.description"></div>

                  </div>
                </div>
              </td>
              <td style="vertical-align: top" *ngFor="let project of projects">
                <div style="display:flex;justify-content:center;gap:10px">
                  <span
                    *ngFor="let pair of (proposedPairingMap[subIitem.projectControlItemId] || {})[project.projectId]"
                    style="color:#ddd; cursor: pointer">
                    <span
                      (click)="addProposedPair(pair.fromControlItemId, pair.toControlItemId)">{{pair.toControlItemName}}</span>
                  </span>
                  <span class="pi pi-plus" (click)="addPair(subIitem.projectControlItemId, project.projectId)"></span>
                </div>

                <div style="display:flex;justify-content:center;gap:10px">
                  <div *ngFor="let pair of (pairingMap[subIitem.projectControlItemId] || {})[project.name]">
                    <div class="pairing-div">
                      <p>{{pair.toControlItemName}}</p>
                      <i class="pi pi-trash" (click)="deletePair(pair.mappedItemId)"></i>
                      <div *ngIf="pair.isEditing">
                        <i class="pi pi-times" (click)="pair.isEditing = false"></i>
                        <i class="pi pi-check" style="margin-left:10px;font-size:15px; color:orange"
                          (click)="saveEdit(pair)"></i>
                      </div>
                    </div>
                    <div [@expandCollapse]="subIitem.controlItem.descriptionVisible ? 'expanded' : 'collapsed'">
                      <section>
                        <ng-container>
                          <div>
                            <div class="Subcompoment-boxes"
                              (click)="pair.showImplementation = !pair.showImplementation">
                              <h2 class="checkbox-heading">Implementation</h2>
                              <i [ngClass]="pair.showImplementation ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </div>
                            <div [@expandCollapse]="pair.showImplementation ? 'expanded' : 'collapsed'"
                              style="display: grid">
                              <div style="display: flex;gap:5px">
                              <mat-checkbox class="small-checkbox" [(ngModel)]="pair.ics1" [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">ICS1</mat-checkbox>
              <p style="margin-bottom: 0px;font-size: 12px;margin-top: 3px;color: grey;" *ngIf="pair.ics1 && pair.ics1Mappedwith">--{{pair.ics1Mappedwith}}</p>

</div>
<div style="display: flex;gap:5px">
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.ics2"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">ICS2</mat-checkbox>
              <p style="margin-bottom: 0px;font-size: 12px;margin-top: 3px;color: grey;"  *ngIf="pair.ics2 && pair.ics2Mappedwith">--{{pair.ics2Mappedwith}}
              </p>

                              </div>
                              <div style="display: flex;gap:5px">
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.ics3"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">ICS3</mat-checkbox>
                                              <p style="margin-bottom: 0px;font-size: 12px;margin-top: 3px;color: grey;" *ngIf="pair.ics3 && pair.ics3Mappedwith">--{{pair.ics3Mappedwith}}
                                              </p>
                     </div>
                              <!-- <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                                [(ngModel)]="pair.implementationControlStatement"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Implementation
                                Control
                                Statement</mat-checkbox> -->
                              <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                                [(ngModel)]="pair.controlsTesting"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Controls
                                Testing</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                                [(ngModel)]="pair.inheritedControls"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Inherited
                                Controls</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                                [(ngModel)]="pair.gaps"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Gaps</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [disabled]="!pair.isEditing"
                                [(ngModel)]="pair.workstream"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Workstream</mat-checkbox>
                            </div>
                            <div class="Subcompoment-boxes" (click)="pair.showArtifacts = !pair.showArtifacts">
                              <h2 class="checkbox-heading">Artifacts & Evidence</h2>
                              <i [ngClass]="pair.showArtifacts ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </div>
                            <div [@expandCollapse]="pair.showArtifacts ? 'expanded' : 'collapsed'"
                              style="display: grid;">
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.evidence"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Evidence</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.policy"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Policy</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.documentation"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Documentation</mat-checkbox>
                            </div>
                            <div class="Subcompoment-boxes" (click)="pair.showAssessment = !pair.showAssessment">
                              <h2 class="checkbox-heading">Assessment</h2>
                              <i [ngClass]="pair.showAssessment ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </div>
                            <div [@expandCollapse]="pair.showAssessment ? 'expanded' : 'collapsed'"
                              style="display: grid;">
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.intAssessment"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Int
                                Assessment</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.thirdPartySecurity"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">3P
                                Security</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.thirdPartyRisk"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">3P
                                Risk</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.areaSpecific"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Area
                                Specific</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.scoring"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Scoring</mat-checkbox>
                            </div>
                            <div class="Subcompoment-boxes" (click)="pair.showNist = !pair.showNist">
                              <h2 class="checkbox-heading">NIST FedRAMP</h2>
                              <i [ngClass]="pair.showNist ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </div>
                            <div [@expandCollapse]="pair.showNist ? 'expanded' : 'collapsed'" style="display: grid;">
                              <mat-checkbox class="example-margin small-checkbox"
                                [(ngModel)]="pair.organizationalParameters" [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Organizational
                                Parameters</mat-checkbox>
                              <mat-checkbox class="example-margin small-checkbox" [(ngModel)]="pair.controlOrigination"
                                [disabled]="!pair.isEditing"
                                (change)="logValue(pair, subIitem.controlItem.complianceAreaControlId)">Control
                                Origination</mat-checkbox>
                            </div>
                          </div>
                        </ng-container>

                      </section>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>

      </p-table>
    </mat-tab>
    <mat-tab label="RizkReport">
      <p-table #table [value]="projectControlItems" rowGroupMode="subheader" [columns]="statusCols"
        dataKey="controlItem.category" expandableRowGroups="true" [paginator]="true" [rows]="100" [pageLinks]="3"
        [rowsPerPageOptions]="[10, 20, 50, 100]" [reorderableColumns]="true" (onSort)="updateRowGroupMetaData()">
        <ng-template pTemplate="caption">
          <div class="ui-helper-clearfix flex flex-row justify-content-end">
            <button type="button" pButton class="risksponge-button" icon="pi pi-file-excel" iconPos="left"
              (click)="table.exportCSV()">
            </button>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
            <th *ngFor="let col of statusCols" [pSortableColumn]="col.field" style="text-align: center;"
              [ngStyle]="{'width': col.width || 'auto'}">
              {{col.header}}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header"
            *ngIf="rowGroupMetadata && rowGroupMetadata[item.controlItem.category].index === rowIndex">
            <td [attr.colspan]="projects?.length+ + 1">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item['controlItem'].complianceArea.name}} - {{item['controlItem'].category}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
          <tr *ngIf="!item.controlItem.hasParent">
            <td>
              <span href="#" *ngIf="item.subItems?.length"
                (click)="statusSubVisible[item.projectControlItemId] = !statusSubVisible[item.projectControlItemId]"
                style="margin-left: 14px;">
                <i
                  [ngClass]="statusSubVisible[item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              </span>
              {{item.controlItem.category}}
            </td>
            <td>
              {{item.controlItem.complianceAreaControlId}}
              <img src="../../../assets/icon/broadcast.svg" height="20px"
                *ngIf="pairingMap[item.projectControlItemId]?.cloned" />
              <img src="../../../assets/icon/crossmap.png" height="20px"
                *ngIf="pairingMap[item.projectControlItemId]?.mapped" />
            </td>
            <td>
              {{implementationStatuses[item.implementationStatus]}}
            </td>
            <td style="text-align: center" *ngFor="let project of projects">
              <div *ngFor="let pair of (pairingMap[item.projectControlItemId] || {})[project.name]"
                [ngStyle]="{fontWeight: pair.isPrimary ? 'bold' : 'normal'}"><span>{{pair.toControlItemCategory}}
                  - {{pair.toControlItemName}} - {{pair.toControlItemImplementationStatus}}</span>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="statusSubVisible[item.projectControlItemId] && item.complianceArea?.hasLevels">
            <ng-container *ngFor="let subItemLevel of item.subItemLevels">
              <tr>
                <td [attr.colspan]="projects?.length+ + 3" style="padding-left: 30px;">
                  <span href="#" *ngIf="item.subItems?.length"
                    (click)="statusSubVisible[item.projectConjtrolItem + '_' + subItemLevel.level] = !statusSubVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
                    <i
                      [ngClass]="statusSubVisible[item.projectConjtrolItem + '_' + subItemLevel.level] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  </span>
                  {{subItemLevel.level}}
                </td>
              </tr>
              <ng-container *ngIf="statusSubVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
                <tr *ngFor="let subIitem of subItemLevel.subItems">
                  <td style="padding-left: 40px;">{{subIitem.controlItem.category}}
                  </td>
                  <td>
                    {{subIitem.controlItem.complianceAreaControlId}}
                    <img src="../../../assets/icon/broadcast.svg" height="20px"
                      *ngIf="pairingMap[item.projectControlItemId]?.cloned" />
                    <img src="../../../assets/icon/crossmap.png" height="20px"
                      *ngIf="pairingMap[item.projectControlItemId]?.mapped" />
                  </td>
                  <td>
                    {{implementationStatuses[subIitem.implementationStatus]}}
                  </td>
                  <td style="text-align: center" *ngFor="let project of projects">
                    <div *ngFor="let pair of (pairingMap[subIitem.projectControlItemId] || {})[project.name]"
                      [ngStyle]="{fontWeight: pair.isPrimary ? 'bold' : 'normal'}">
                      <span>{{pair.toControlItemCategory}} - {{pair.toControlItemName}}
                        - {{pair.toControlItemImplementationStatus}}</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="statusSubVisible[item.projectControlItemId] && !item.complianceArea?.hasLevels">
            <tr *ngFor="let subIitem of item.subItems">
              <td style="padding-left: 40px;">{{subIitem.controlItem.category}}
              </td>
              <td>
                {{subIitem.controlItem.complianceAreaControlId}}
                <img src="../../../assets/icon/broadcast.svg" height="20px"
                  *ngIf="pairingMap[item.projectControlItemId]?.cloned" />
                <img src="../../../assets/icon/crossmap.png" height="20px"
                  *ngIf="pairingMap[item.projectControlItemId]?.mapped" />
              </td>
              <td>
                {{implementationStatuses[subIitem.implementationStatus]}}
              </td>
              <td style="text-align: center" *ngFor="let project of projects">
                <div *ngFor="let pair of (pairingMap[subIitem.projectControlItemId] || {})[project.name]"
                  [ngStyle]="{fontWeight: pair.isPrimary ? 'bold' : 'normal'}">
                  <span>{{pair.toControlItemCategory}} - {{pair.toControlItemName}}
                    - {{pair.toControlItemImplementationStatus}}</span>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>

      </p-table>
    </mat-tab>
  </mat-tab-group>
</div>
